import React from 'react'

import './fontFlow.css'

export default ({ style = {} }) => (
    <span style={style} className="font-flow">{process.env.REACT_APP_NAME}</span>
)